

 
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import UserToken from "../../Infra/GetUserToken";

import { useLoading } from "../LoadingProvider";

const FileUploader = ({ onUpload , defaultImageUrl = null}) => {
  const [preview, setPreview] = useState(null);
  const [uploadedUrl, setUploadedUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

    const BASE_URL = process.env.REACT_APP_BASE_URL;


    
    const token = UserToken(); 

    const { toast } = useLoading()

    useEffect(() => {
  if (defaultImageUrl) {
    setUploadedUrl(BASE_URL+defaultImageUrl);
    setPreview(BASE_URL+defaultImageUrl);
  }
  else{
      setUploadedUrl(null);
    setPreview(null);
  }
}, [defaultImageUrl]);


    const handleDelete = async () => {
  try {
    await axios.delete(BASE_URL+"/api/files/delete", {
      data: { url: uploadedUrl },
      headers: {
            "Authorization": `Bearer ${token}`
        }
    });
    setUploadedUrl(null);
    setPreview(null);
    setError(null)
    if (onUpload) onUpload(""); // Clear image in parent form
  } catch (err) {
    console.error(err);
    setError("Failed to delete file.");
    toast.error("Failed to delete file.")

  }
};



  const onDrop = useCallback(async (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;

    setError("");
    setUploading(true);
    setPreview(URL.createObjectURL(file));

    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await axios.post(BASE_URL+"/api/files/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`

        }
      });

      const fileUrl = res.data.url;
      setUploadedUrl(fileUrl);
      if (onUpload) onUpload(fileUrl);
    } catch (err) {
      console.error(err);
      setError("Upload failed. Please try again.");
      toast.error("Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  }, [onUpload]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      "image/*": [] // allow only images, optional
    }
  });

  return (
    <div>
      <div
        {...getRootProps()}
        className={`border border-2 p-4 rounded text-center ${isDragActive ? "bg-light" : ""}`}
        style={{ cursor: "pointer" }}
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <p className="text-primary fw-bold">Drop the file here...</p>
        ) : (
          <p>Drag & drop a file here, or click to select</p>
        )}
      </div>

      {uploading && (
        <div className="text-center mt-3">
          <Spinner animation="border" size="sm" /> Uploading...
        </div>
      )}

      {error && <div className="alert alert-danger mt-3">{error}</div>}

      {preview && (
        <div className="mt-4 text-center">
          <p className="fw-bold">Preview:</p>
          <img
            src={preview}
            alt="preview"
            className="img-thumbnail"
            style={{ maxWidth: "200px" }}
          />
        </div>
      )}

      {uploadedUrl && (
  <div className="mt-3 text-center">
    <p className="fw-bold text-success">Uploaded!</p>
    {/* <a href={uploadedUrl} target="_blank" rel="noopener noreferrer" className="text-decoration-underline d-block mb-2">
      {uploadedUrl}
    </a> */}
    <button
      className="btn btn-outline-danger btn-sm"
      onClick={handleDelete}
    >
      Delete Image
    </button>
  </div>
)}


{/* 
      {uploadedUrl && (
        <div className="mt-3 text-center">
          <p className="fw-bold text-success">Uploaded!</p>
          <a href={uploadedUrl} target="_blank" rel="noopener noreferrer" className="text-decoration-underline">
            {uploadedUrl}
          </a>
        </div>
      )} */}
    </div>
  );
};

export default FileUploader;
